module.exports = __webpack_public_path__ + "media/images/icons/grid-two-up-62ae4c9967681da6a48e0b72e59357aa.svg";